import React, {useEffect} from 'react'

import template from './templates-promo.twig'

import parse from 'html-react-parser'

import legacyJs from './templates-promo.legacy'

import {
  Asset,
  ButtonOptions,
  ContentOptions,
  HeadlineOptions,
  LinkOptions,
  WorkshopsColors,
} from '@miro-site/components_utils'

export type Template = {
  link: LinkOptions
  image: Asset
  headline: HeadlineOptions
}

export type TemplatesPromoProps = {
  children?: React.ReactNode
  background?: WorkshopsColors
  rtl?: '0' | '1'
  button: ButtonOptions
  content: ContentOptions
  headline: HeadlineOptions
  templates: Template[]
}

import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

const TemplatesPromo = (props: TemplatesPromoProps): React.ReactElement => {
  useEffect(() => {
    legacyJs.init()
  }, [])

  return (
    <>
      {parse(
        template({
          ...props,
          component_name: 'Templates Promo Section',
        }),
      )}
    </>
  )
}

export default TemplatesPromo
